import types from "./types";
import {createError, logError} from "../../ui/Notify";
import api from "../api/organizations";

function requestOrgDepartments() {
  return {
    type: types.GET_ORG_DEPARTMENTS_REQUEST,
    isFetchingDepartments: true
  };
}

function requestOrgDepartmentsCompleted(departmentList) {
  return {
    type: types.GET_ORG_DEPARTMENTS_COMPLETE,
    isFetchingDepartments: false,
    departmentList
  };
}

function requestOrgDepartmentsError(departmentListError) {
  return {
    type: types.GET_ORG_DEPARTMENTS_ERROR,
    isFetchingDepartments: false,
    departmentListError
  };
}

export function getOrgDepartments(orgId) {
  return dispatch => {
    dispatch(requestOrgDepartments());
    return api.getOrganizationDepartments(orgId)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestOrgDepartmentsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestOrgDepartmentsError(message));
        } else {
          logError(err);
          dispatch(requestOrgDepartmentsError(createError("Не удалось загрузить список подразделений организации")));
        }
      });
  };
}

function requestOrgList() {
  return {
    type: types.GET_ORG_LIST_REQUEST,
    isFetchingOrgList: true
  };
}

function requestOrgListCompleted(orgList) {
  return {
    type: types.GET_ORG_LIST_COMPLETE,
    isFetchingOrgList: false,
    orgList
  };
}

function requestOrgListError(orgListError) {
  return {
    type: types.GET_ORG_LIST_ERROR,
    isFetchingOrgList: false,
    orgListError
  };
}

export function getOrganizations() {
  return dispatch => {
    dispatch(requestOrgList());
    return api.getOrganizationsList()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestOrgListCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestOrgListError(message));
        } else {
          logError(err);
          dispatch(requestOrgListError(createError("Не удалось загрузить список организаций")));
        }
      });
  };
}

export function getOrganizationsSelect() {
  return dispatch => {
    dispatch(requestOrgList());
    return api.getOrganizationsSelectList()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestOrgListCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestOrgListError(message));
        } else {
          logError(err);
          dispatch(requestOrgListError(createError("Не удалось загрузить список организаций")));
        }
      });
  };
}

export default {
  getOrgDepartments,
  getOrganizations,
  getOrganizationsSelect
};
